// Component for handling chat/messaging functionality with features:

import React, {
  useCallback,
  useRef,
  useState,
  useEffect,
  useLayoutEffect,
} from "react";
import {
  HStack,
  Box,
  VStack,
  Text,
  Button,
  Input,
  TextArea,
  ScrollView,
  FlatList,
  Pressable,
  Divider,
  CloseIcon,
  AddIcon,
  Image,
  IconButton,
} from "native-base";
import type { ScrollView as ScrollViewType } from "react-native";
import { useWindowDimension } from "../../../Utility/WindowDimensions";
import { Loc } from "../../../App/Loc";
import AVCancel from "../../../components/common/AVCancel";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../types_interface/RootState";
import ProfilePic from "../../../components/common/ProfilePicture";
import * as AV from "../../../AVCore/AVCore";
import { IPost as AVPost } from "../../../AVCore/Interfaces/Post";
import { IMedia as AVMedia } from "../../../AVCore/Interfaces/Media";
import { IAVEntity } from "../../../AVCore/Interfaces/AVEntity";
import { ILink } from "../../../AVCore/Interfaces/AV.Interfaces";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import ConvoCard from "../message/MessageBubble";
import EmojiPicker from "emoji-picker-react";
import FilePicker from "../../../Platform/FilePicker";
import { AVButtonRoundedFull } from "../../../components/common/AVButtons";
import { ActivityIndicator } from "react-native";
import { setConvo } from "../../../Redux/Actions/convoActions";
import { AVBase } from "../../../AVCore/AVBase";
import { SignalRService } from "../../../AVCore/SignalR";
import {
  PaperPlaneIcon,
  MoreHorizontalIcon,
} from "../../../assets/icons/icon-assets";
import InsufficientCredits from "../../../assets/images/InsufficientCredits.png";
import AVInputtext from "../../../components/AVInputtext";
import AVConfirmationModal from "../../../components/common/AVConfirmationModal";
import settings from "../../../Platform/settings.json";
import Tooltip from "@mui/material/Tooltip";
import { setIsConvoScreenOpen } from "../../../Redux/Actions/userActions";
import { debounce } from "lodash";
import Webcam from "react-webcam";
import { FiCamera, FiVideo } from "react-icons/fi";
import ExternalLink from "../../../components/common/ExternalLink";
import ManageConvoPopup from "../conversations/ManageConversation";
import VoiceMessage from "../../../components/common/VoiceMessage";
import ChatHeader from "../components/ChatHeader";
import ChatFooterEmoji from "../footer/CustomFooterEmoji";
import FormattingPostPopup from "./FormattingPostPopup";
import Moment from "moment";
import { Loader } from "../../../components/loaders";

// Define interfaces for the component props and state
interface IPost extends AVPost {
  status?: string;
  pk?: string;
  parentPost?: string;
  person?: {
    id: string;
    title?: string;
  };
  media?: AVMedia;
  impressions?: Array<{
    id: string;
    impression: string;
  }>;
  galleryPost?: AVMedia[];
  ReplyPost?: IPost[];
}

interface IConvo {
  id: string;
  enabled?: boolean;
  subject?: string;
  type?: string;
  people?: Array<{
    id: string;
    title?: string;
  }>;
  posts?: IPost[];
}

interface IUser {
  id: string;
  title?: string;
}

interface IEntityData extends IAVEntity {
  id: string;
  title?: string;
}

interface IListItemParam {
  source: string;
  type: string;
}

interface IConvoPost extends IPost {
  galleryPost?: AVMedia[];
  ReplyPost?: IPost[];
}

interface IUserConvo extends IConvo {
  posts?: IConvoPost[];
}

const Messages = ({
  isHeader,
  setShowEmoji,
  RenderImages,
  showEmoji,
  imageInputRef,
  onEmojiClick,
  handleuserRedirect,
  getItemLayout,
  setIsOpenBox,
  setIsOpenCemera,
  HandleAddExternalUrl,
  handleOpenPicker,
  setExternalLink,
  HandleAddOneDrive,
  setShowExternalLinkInput,
  showExternalLinkInput,
  HandleAddDropBoxLink,
  ReplyLoadMedia,
  setHeader,
  setShowAllImage,
  setSingleImage,
  setShowPreview,
  setConvoImage,
  setItemHeights,
  itemHeights,
  setIsdelete,
  props,
  mdlConvoVisible,
  textSearchRef,
  mdlCreateConvoVisible,
  setMdlCreateConvoVisible,
  toFK,
  isOpenConvo,
  isNewChat,
  setIsNewChat,
  isConvoData,
  setConvoSubject,
  isGroupChat,
  setIsGroupChat,
  setIsOpenConvo,
  searchInput,
  filteredResults,
  showSearch,
  showFilePicker,
  handleCreateModel,
  isYoutube,
  setIsYouTube,
  typingUserName,
  searchItems,
  handleSentToProfile,
  handleSendMessage,
  setConvoLoading,
  isLoading,
  handleSubject,
  subject,
  handleExternalLink,
  externalLink,
  handleMessage,
  handleRemoveItem,
  getImageGalleryFromFilePickerCreateConvo,
  convoSubject,
  setShowConvoListModal,
  setMdlConvoVisible,
  convoPost,
  convo,
  showConvoFilePicker,
  handleGetConvo,
  handleSendConvoMessage,
  replyValue,
  setreplyValue,
  handleChatMessage,
  media,
  value,
  camera,
  profile,
  Setprofile,
  setValue,
  Loading,
  images,
  setImages,
  setDeletedImages,
  videoUrls,
  setvideos,
  handleImages,
  handleVoice,
  handleFilePicker,
  onRefresh,
  setSubject,
  settoFK,
  handlePublish,
  setIsHide,
  isSetText,
  isHide,
  isImageProcessing,
  setMedia,
  refConvoList,
  setShowConvoFilePicker,
  HandleEditSet,
  handleUpdatePost,
  itemEdit,
  setShowSearch,
  editingImage,
  setSearchInput,
  setUpdateConvoImage,
  setUpdateConvoVideo,
  setEditingImage,
  setItemEdit,
  setConvoPost,
  fetchloading,
  setConvos,
  isOpenCemera,
  setIsConvoData,
  isOpenBox,
  isHuddleChatTab,
  shrink,
  setShrink,
  handleTranslateText,
  handleShowOriginalText,
  setIsOneDriveData,
  showInsufficientCredits,
  setShowInsufficientCredits,
  scrollRef,
  prevScrollHeightRef,
  prevScrollTopRef,
  loadingOldMessagesRef,
  messagesEndRef,
  setupSignalRConnection,
  cameraMode,
  setCameraMode,
  webcamRef,
  recording,
  setRecording,
  duration,
  setDuration,
  formatDuration,
  toggleMode,
  isCancelledRef,
  handleCameraPhotoCapture,
  handleStartRecording,
  handleStopRecording,
  onClose,
  addLinkLoad,
  setAddLinkLoad,
  editorRef,
  useRichText,
  setUseRichText,
  rteValue,
  setRteValue,
  toolbarOptions,
  isExpanded,
  setIsExpanded,
  setPostPopupExpanded,
  bgColor,
  setBgColor,
  bgImage,
  setBgImage,
  bgImgWidth,
  setBgImgWidth,
  bgImgHeight,
  setBgImgHeight,
  entityData,
}) => {
  const dimensions = useWindowDimension();
  const isMobile = dimensions?.width <= 500 || false;
  const stateUser = useSelector((state: RootState) => state);
  const currentUser = stateUser?.user?.user[0] as IUser;
  const navigate = useNavigate();
  const [renderedItems, setRenderedItems] = React.useState<any[]>([]);
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectItem, setSelectItem] = React.useState<IPost | null>(null);
  const [showFeedbackImpressions, setShowFeedbackImpressions] =
    React.useState(false);
  const userconvo = useSelector(
    (state: RootState) => state.convo.convo[0],
  ) as unknown as IUserConvo[];
  let id = convo?.id == undefined ? isConvoData : convo?.id;
  const currentConvo = userconvo?.filter((x) => x?.id == id) || [];
  const currentConvoFirstItem =
    currentConvo.length > 0 ? currentConvo[0] : null;
  const filteredConvoPost =
    currentConvoFirstItem?.posts?.filter((x) => x?.status !== "Deleted") || [];
  const [isConfirmDelete, setisConfirmDelete] = useState(false);
  const [Confirmationtext, setConfirmationtext] =
    React.useState("Are you sure ?");
  const [selectType, setselectType] = React.useState<string | undefined>(
    undefined,
  );
  const [itemSelect, setItemSelect] = React.useState<IPost | null>(null);
  const [isLoader, setLoader] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const [isDeleteLoading, setisdeleteLoading] = React.useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const entitydatalist = useSelector(
    (state: RootState) => state.user.entitydatalist,
  ) as IEntityData[];
  const [showManageConvoPopup, setShowManageConvoPopup] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState<number>(0);
  const [waveformBars, setWaveformBars] = useState<number[]>(
    Array.from({ length: 30 }, () => Math.random() * 12 + 4),
  );

  React.useEffect(() => {
    if (!isMobile && mdlConvoVisible) {
      inputRef?.current?.focus();
    }
  }, [convoPost, mdlConvoVisible, isMobile]);

  React.useEffect(() => {
    setConvoSubject(currentConvo[0]?.subject);
    if (
      currentConvo &&
      currentConvo?.length > 0 &&
      currentConvo[0]?.type !== "GroupConvo" &&
      ((currentConvo && currentConvo[0]) || (userconvo && userconvo[0]))
    ) {
      handleGetConvo(
        currentConvo && currentConvo[0]
          ? currentConvo[0]
          : userconvo && userconvo[0],
      );
    }
  }, [isOpenConvo, isConvoData, convo]);

  // Handles key press events for sending messages, with special handling for Enter key
  const handleKeyPress = (event) => {
    if (convo?.enabled === false) {
      return false;
    }

    if (event.key === "Enter" && !event.shiftKey && value?.trim()?.length > 0) {
      if (value?.trim()?.length > 0 && isOpenConvo) {
        if (isImageProcessing) {
          event.preventDefault();
        }
        if (itemEdit.length !== 0) {
          handleUpdatePost(itemEdit);
        } else if (!isMobile && !isLoading) {
          handleSendConvoMessage(convo);
        }
      } else {
        if (
          toFK.length > 1 &&
          subject &&
          !isLoading &&
          (value?.trim()?.length === 0 || media?.length === 0)
        ) {
          handleSendMessage();
        }
        if (
          toFK.length == 1 &&
          (value?.trim()?.length === 0 || media?.length === 0)
        ) {
          handleSendMessage();
        }
      }
    }
  };

  const menuRefs = useRef(null);
  const exceptionRef = useRef(null);
  const addPhotoIconRef = useRef(null);

  useOutsideAlerter(menuRef, exceptionRef);

  // Custom hook to handle clicks outside of menu elements
  function useOutsideAlerter(ref, exceptionRef) {
    React.useEffect(() => {
      // Alert if clicked on outside of element
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowFeedbackImpressions(false);
          setIsOpen(false);
          setIsOpenBox(false);
          setShowEmoji(false);
        } else if (
          ref.current &&
          !ref.current.contains(event.target) &&
          !(exceptionRef.current && exceptionRef.current.contains(event.target))
        ) {
          setShowEmoji(false);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, exceptionRef]);
  }

  // Handles adding or removing reactions to posts
  const handleLikePost = async (type: string) => {
    try {
      if (!selectItem) return;

      // Find the existing impression of the current user
      let existingImpression = selectItem.impressions?.find(
        (x) => x?.id === currentUser?.id,
      );

      if (!existingImpression || existingImpression.impression !== type) {
        // Optimistically update the state to show the impression immediately
        let optimisticImpressions = existingImpression
          ? selectItem.impressions?.filter((x) => x.id !== currentUser.id) || []
          : selectItem.impressions || [];

        let optimisticImpression = {
          id: currentUser.id,
          impression: type,
        };

        let optimisticSelectItem = {
          ...selectItem,
          impressions: [...optimisticImpressions, optimisticImpression],
        };

        // Update the conversation posts optimistically
        updateConversationPosts(optimisticSelectItem);

        // Call the API to add the impression
        let val = await AV.Post.addImpression(selectItem, type);
      } else {
        // Optimistically remove the impression from the UI immediately
        let optimisticImpressions =
          selectItem.impressions?.filter((x) => x.id !== currentUser.id) || [];
        let optimisticSelectItem = {
          ...selectItem,
          impressions: optimisticImpressions,
        };

        // Update the conversation posts optimistically
        updateConversationPosts(optimisticSelectItem);

        // Remove impression if already liked with the same type
        await handleremoveLike(type);
      }
    } catch (error) {
      console.error("Error handling like post:", error);
    }

    setShowFeedbackImpressions(false);
  };

  // Updates conversation posts with new impression data
  const updateConversationPosts = (updatedItem: IPost) => {
    let index = convoPost?.findIndex((a) => a?.id === updatedItem?.id);
    if (index !== -1 && convoPost) {
      convoPost[index] = updatedItem;
    }

    let userFeedsImpre = userconvo?.find((x) => x?.id === updatedItem?.pk);
    if (userFeedsImpre && userFeedsImpre.posts) {
      let postIndex = userFeedsImpre.posts.findIndex(
        (x) => x?.id === updatedItem?.id,
      );
      if (postIndex !== -1) {
        userFeedsImpre.posts[postIndex] = updatedItem;
        setConvoPost([...userFeedsImpre.posts]);
        let chatIndex = userconvo.findIndex((x) => x.id === userFeedsImpre!.id);
        if (chatIndex !== -1) {
          userconvo[chatIndex] = userFeedsImpre;
        }
      }
    }
  };

  // Processes API response and updates conversation state
  const handleApiResponse = (val: IConvoPost) => {
    if (val && selectItem) {
      const selectItemPost = selectItem as IConvoPost;
      if (selectItemPost.galleryPost && selectItemPost.galleryPost.length > 0)
        val.galleryPost = selectItemPost.galleryPost;
      if (selectItemPost.ReplyPost && selectItemPost.ReplyPost.length > 0)
        val.ReplyPost = selectItemPost.ReplyPost;

      let index = convoPost?.findIndex((a) => a?.id === val.id);
      if (index !== -1 && convoPost) {
        convoPost[index] = val;
      }

      let userFeedsImpre = userconvo?.find(
        (x) => x.id === val.pk,
      ) as IUserConvo;
      if (userFeedsImpre && userFeedsImpre.posts) {
        let postIndex = userFeedsImpre.posts.findIndex((x) => x.id === val.id);
        if (postIndex !== -1) {
          userFeedsImpre.posts[postIndex] = val;
          setConvoPost([...userFeedsImpre.posts]);
          let chatIndex = userconvo.findIndex(
            (x) => x.id === userFeedsImpre.id,
          );
          if (chatIndex !== -1) {
            userconvo[chatIndex] = userFeedsImpre;
            dispatch(setConvo(userconvo));
          }
        }
      }
    }
  };

  // Removes a reaction from a post
  const handleremoveLike = async (type: string) => {
    if (!selectItem) return;

    const selectItemPost = selectItem as IConvoPost;
    let val = await AV.Post.removeImpression(selectItemPost, type);

    // Update val if necessary
    if (
      selectItemPost.galleryPost &&
      selectItemPost.galleryPost.length > 0 &&
      val
    ) {
      (val as IConvoPost).galleryPost = selectItemPost.galleryPost;
    }
    if (
      selectItemPost.ReplyPost &&
      selectItemPost.ReplyPost.length > 0 &&
      val
    ) {
      (val as IConvoPost).ReplyPost = selectItemPost.ReplyPost;
    }

    // Update convoPost
    let index = convoPost?.findIndex((a) => a?.id === selectItemPost?.id);
    if (index !== -1 && convoPost) {
      convoPost[index] = val as IConvoPost;
      setConvoPost([...convoPost]);
    }

    // Update userconvo
    let userFeedsImpre = userconvo?.filter((x) => x?.id === val.pk);
    if (userFeedsImpre && userFeedsImpre.length > 0 && userFeedsImpre[0]) {
      const currentFeed = userFeedsImpre[0];
      if (currentFeed.posts) {
        let userFeedsImpression = currentFeed.posts.filter(
          (b) => b?.id === val?.id,
        );
        if (
          userFeedsImpression &&
          userFeedsImpression.length > 0 &&
          userFeedsImpression[0]
        ) {
          const userFeed = userconvo[0] as IUserConvo;
          if (userFeed.posts) {
            const postIndex = userFeed.posts.findIndex(
              (post) => post.id === (userFeedsImpression[0] as IConvoPost).id,
            );
            if (postIndex !== -1) {
              userFeed.posts[postIndex] = val as IConvoPost;
              const chatIndex = userconvo.findIndex(
                (x) => x.id === userFeed.id,
              );
              if (chatIndex !== -1) {
                userconvo[chatIndex] = userFeed;
                dispatch(setConvo(userconvo));
              }
            }
          }
        }
      }
    }

    setShowFeedbackImpressions(false);
  };

  // Initiates the message deletion process
  const handleDeleteMessage = () => {
    if (!selectItem) return;
    setisConfirmDelete(true);
    setConfirmationtext(Loc.currentLang.menu.deleteConvoConfirmText);
    setItemSelect(selectItem);
    setselectType("DeleteConvo");
  };

  // Handles the actual deletion of a conversation message
  const handleDelteconvo = async () => {
    if (!itemSelect) return;

    let selectItem = itemSelect;
    let selectedReply = convoPost?.filter(
      (a) => a?.parentPost === selectItem?.id,
    );

    setLoader(true);

    // Deleting the selected item
    await AV.Post.delete(selectItem).then((x) => {
      selectItem.status = "Deleted";
      setConvoPost(convoPost?.filter((a) => a?.id !== selectItem?.id));

      let userFeedsImpre = userconvo?.filter((x) => x?.id === selectItem?.pk);
      if (userFeedsImpre && userFeedsImpre.length > 0 && userFeedsImpre[0]) {
        let userFeedsImpression: any = userFeedsImpre[0]?.posts?.filter(
          (b) => b?.id === selectItem?.id,
        );
        if (
          userFeedsImpression &&
          userFeedsImpression.length > 0 &&
          userFeedsImpression[0]
        ) {
          const userFeed = userconvo[0] as IUserConvo;
          if (userFeed.posts) {
            const postIndex = userFeed.posts.findIndex(
              (post) => post.id === userFeedsImpression[0].id,
            );
            if (postIndex !== -1) {
              userFeed.posts[postIndex] = selectItem;
              const chatIndex = userconvo.findIndex(
                (x) => x.id === userFeed.id,
              );
              if (chatIndex !== -1) {
                userconvo[chatIndex] = userFeed;
                dispatch(setConvo(userconvo));
              }
            }
          }
        }
      }
    });

    if (selectedReply && selectedReply.length > 0) {
      // Deleting the selected replies
      await AV.Post.delete(selectedReply[0]).then((x) => {
        selectedReply.forEach((reply) => {
          reply.status = "Deleted";
          setConvoPost(convoPost?.filter((a) => a?.id !== reply?.id));

          let userFeedsImpre = userconvo?.filter((x) => x?.id === reply?.pk);
          if (
            userFeedsImpre &&
            userFeedsImpre.length > 0 &&
            userFeedsImpre[0]
          ) {
            let userFeedsImpression: any = userFeedsImpre[0]?.posts?.filter(
              (b) => b?.id === reply?.id,
            );
            if (
              userFeedsImpression &&
              userFeedsImpression.length > 0 &&
              userFeedsImpression[0]
            ) {
              const userFeed = userconvo[0] as IUserConvo;
              if (userFeed.posts) {
                const postIndex = userFeed.posts.findIndex(
                  (post) => post.id === userFeedsImpression[0].id,
                );
                if (postIndex !== -1) {
                  userFeed.posts[postIndex] = reply;
                  const chatIndex = userconvo.findIndex(
                    (x) => x.id === userFeed.id,
                  );
                  if (chatIndex !== -1) {
                    userconvo[chatIndex] = userFeed;
                    dispatch(setConvo(userconvo));
                  }
                }
              }
            }
          }
        });
      });
    }
    setIsOpen(false);
    setLoader(false);
    setisConfirmDelete(false);
  };

  // Renders individual conversation items
  const renderItem = useCallback(
    ({ item }) => {
      if (!item) return null;

      if (item.type === "date-separator") {
        // Format the date
        const formatted = Moment(item.date).calendar(null, {
          sameDay: `[${Loc.currentLang.calendar.today}] hh:mm a`,
          lastDay: `[${Loc.currentLang.convo.yesterday}] hh:mm a`,
          lastWeek: "dddd hh:mm a",
          sameElse: "DD MMM hh:mm a",
        });
        return (
          <Box width="100%" alignItems="center" my={2}>
            <Text
              fontSize={"14px"}
              color="gray.500"
              backgroundColor="#fff"
              px={3}
              py={1}
              borderRadius="md"
            >
              {formatted}
            </Text>
          </Box>
        );
      }
      return (
        <ConvoCard
          id={item.id}
          data={item}
          {...props}
          convoPost={convoPost}
          itemHeights={itemHeights}
          setItemHeights={setItemHeights}
          replyValue={replyValue}
          setreplyValue={setreplyValue}
          profile={profile}
          setConvoImage={setConvoImage}
          setShowPreview={setShowPreview}
          setSingleImage={setSingleImage}
          setShowAllImage={setShowAllImage}
          setHeader={setHeader}
          HandleEditSet={HandleEditSet}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          selectItem={selectItem}
          setSelectItem={setSelectItem}
          setShowFeedbackImpressions={setShowFeedbackImpressions}
          showFeedbackImpressions={showFeedbackImpressions}
          setMdlCreateConvoVisible={setMdlCreateConvoVisible}
          setShowConvoListModal={setShowConvoListModal}
          setMdlConvoVisible={setMdlConvoVisible}
          setConvoLoading={setConvoLoading}
          setIsOpenConvo={setIsOpenConvo}
          mdlCreateConvoVisible={mdlCreateConvoVisible}
          isOpenConvo={isOpenConvo}
          itemEdit={itemEdit}
          setItemEdit={setItemEdit}
          handleTranslateText={handleTranslateText}
          handleShowOriginalText={handleShowOriginalText}
          isHuddleChatTab={isHuddleChatTab}
        />
      );
    },
    [
      convoPost,
      itemHeights,
      replyValue,
      setreplyValue,
      profile,
      setConvoImage,
      setShowPreview,
      setSingleImage,
      setShowAllImage,
      setHeader,
      HandleEditSet,
      itemEdit,
      setItemEdit,
      isOpen,
      setIsOpen,
      setShowFeedbackImpressions,
      showFeedbackImpressions,
      setMdlCreateConvoVisible,
      setShowConvoListModal,
      setMdlConvoVisible,
      setConvoLoading,
      setIsOpenConvo,
      mdlCreateConvoVisible,
      isOpenConvo,
      handleTranslateText,
      handleShowOriginalText,
    ],
  );

  // Handles reaching the end of the conversation list
  const onEndReached = useCallback(() => {
    if (scrollRef.current) {
      // @ts-ignore
      prevScrollHeightRef.current = scrollRef.current.scrollHeight;
      // @ts-ignore
      prevScrollTopRef.current = scrollRef.current.scrollTop;
      loadingOldMessagesRef.current = true;
    }
    onRefresh();
  }, [onRefresh]);

  // Debounced handler for chat messages to prevent rapid updates
  const debouncedHandleChatMessage = useCallback(
    debounce((e) => {
      handleChatMessage(e);
    }, 10),
    [handleChatMessage],
  );

  // Updates the list of rendered items
  const updateRenderedItems = useCallback((items) => {
    setRenderedItems(items);
  }, []);

  const feedbackOptions = [
    { impression: "Like", title: "Like", uri: settings.like },
    { impression: "Unlike", title: "Unlike", uri: settings.unlike },
    { impression: "heart", title: "Heart", uri: settings.heart },
    { impression: "Wow", title: "Wow", uri: settings.wow },
    { impression: "Lol", title: "Lol", uri: settings.lol },
    { impression: "Cheer", title: "Cheer", uri: settings.cheer },
    { impression: "Question", title: "Question", uri: settings.question },
    { impression: "broken", title: "broken", uri: settings.broken },
    { impression: "Sad", title: "Sad", uri: settings.sad },
    { impression: "Mad", title: "Mad", uri: settings.mad },
  ];

  // Handles reaction button press
  const handlePress = (type) => {
    handleLikePost(type);
    setShowFeedbackImpressions(false);
    setIsOpen(false);
  };

  // Initiates group chat management
  const handleManageGroup = () => {
    setIsHide(true);
    setIsGroupChat(true);
    setMdlConvoVisible(false);
    setIsOpenConvo(false);
    setSubject(convo?.subject);
    setreplyValue("");
    setShowSearch(false);
    setIsNewChat(false);
    setSearchInput("");
    settoFK(
      convo?.people?.filter((x: AV.IPerson) => x?.id !== currentUser?.id),
    );
  };

  // Saves group chat changes
  const handleSave = async () => {
    await handlePublish();
    setIsGroupChat(false);
    setIsOpenConvo(true);
  };

  // Processes completed voice recordings
  const handleVoiceRecordingComplete = async (audioBlob: Blob) => {
    try {
      setConvoLoading(true);

      // Create a File from the Blob
      const audioFile = new File([audioBlob], "voice-message.wav", {
        type: "audio/wav",
      });

      // Create a FormData object to send the file
      const formData = new FormData();
      formData.append("file", audioFile);

      // Upload the audio file using your existing file upload mechanism
      const uploadedMedia = await handleVoice([audioFile]);

      if (uploadedMedia) {
        // If in a conversation, send the voice message
        if (isOpenConvo) {
          handleSendConvoMessage(convo, uploadedMedia);
        } else {
          // Handle sending voice message in new chat
          setMedia(uploadedMedia);
        }
      }
    } catch (error) {
      console.error("Error handling voice message:", error);
    } finally {
      setConvoLoading(false);
    }
  };

  React.useEffect(() => {}, [userconvo, convoPost]);

  // Generates waveform data for voice recording visualization
  const generateWaveform = useCallback(() => {
    setWaveformBars(Array.from({ length: 30 }, () => Math.random() * 12 + 4));
  }, []);

  // Update waveform during recording
  useEffect(() => {
    let intervalId: NodeJS.Timeout;
    if (isRecording) {
      intervalId = setInterval(generateWaveform, 100);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isRecording, generateWaveform]);

  // Update recording time
  useEffect(() => {
    let timerRef: NodeJS.Timeout;
    if (isRecording) {
      timerRef = setInterval(() => {
        setRecordingTime((prev) => prev + 1);
      }, 1000);
    }
    return () => {
      if (timerRef) {
        clearInterval(timerRef);
      }
    };
  }, [isRecording]);

  // Reset recording time when recording stops
  useEffect(() => {
    if (!isRecording) {
      setRecordingTime(0);
    }
  }, [isRecording]);

  const [messageMenuRight, setMessageMenuRight] = React.useState("20%");
  const [emojiHeight, setEmojiHeight] = React.useState("73%");

  useEffect(() => {
    const calculateZoomLevel = () => {
      return (window.outerWidth / window.innerWidth) * 100;
    };

    const updateSize = () => {
      const zoomLevel = Math.round(calculateZoomLevel());

      // Right position for message menu
      let right;
      if (zoomLevel >= 110) right = isHuddleChatTab ? "10%" : "22%";
      else if (zoomLevel >= 100) right = isHuddleChatTab ? "15%" : "20%";
      else if (zoomLevel >= 90) right = isHuddleChatTab ? "18%" : "18%";
      else if (zoomLevel >= 80) right = isHuddleChatTab ? "22%" : "15%";
      else if (zoomLevel >= 75) right = isHuddleChatTab ? "24%" : "15%";
      else if (zoomLevel >= 67) right = isHuddleChatTab ? "27%" : "13%";
      else if (zoomLevel >= 50) right = isHuddleChatTab ? "33%" : "10%";
      else right = "10%"; // fallback

      setMessageMenuRight(right);

      // Height for emoji
      let height;
      if (zoomLevel >= 110) height = "83%";
      else if (zoomLevel >= 100) height = "73%";
      else if (zoomLevel >= 90) height = "62%";
      else if (zoomLevel >= 80) height = "53%";
      else if (zoomLevel >= 75) height = "48%";
      else if (zoomLevel >= 67) height = "41%";
      else if (zoomLevel >= 50) height = "28%";
      else height = "25%"; // fallback

      setEmojiHeight(height);
    };

    window.addEventListener("resize", updateSize);
    updateSize(); // Initial call

    return () => {
      window.removeEventListener("resize", updateSize);
    };
  }, [isHuddleChatTab]);

  // Handles navigation to user profile
  const handleNavigateToProfile = async () => {
    setShowConvoListModal(false);
    setMdlConvoVisible(false);
    setMdlCreateConvoVisible(false);
    setConvoLoading(false);
    props?.setIsOpenConvo(false);

    navigate(`/profile/${profile?.id}/${profile?.region}`, {
      state: { user: profile },
    });
  };

  // Creates entity link for profile pictures
  const handleGetEntityLink = (entity: IEntityData | undefined): AV.ILink => {
    if (!entity) {
      return {
        id: "",
        type: "",
        title: "",
      };
    }
    return AV.AVEntity.getLink(entity as IAVEntity);
  };

  function insertDateSeparators(messages) {
    const result: any = [];
    let lastDate: any = null;

    // Process in reverse for inverted FlatList
    [...messages].reverse().forEach((msg) => {
      const dateObj: Date = msg?.createDate
        ? new Date(msg.createDate)
        : new Date();
      const dateStr = dateObj.toDateString();

      if (dateStr !== lastDate) {
        result.push({
          type: "date-separator",
          date: dateObj,
          id: `separator-${dateObj.getTime()}`,
        });
        lastDate = dateStr;
      }
      result.push(msg);
    });

    // Reverse back for FlatList inverted rendering
    return result;
  }

  const messagesWithSeparators = insertDateSeparators(filteredConvoPost);

  //#region scroll bar section
  const prepareLoadOlder = () => {
    const container = scrollRef.current;
    if (!container || loadingOldMessagesRef.current) return;

    prevScrollHeightRef.current = container.scrollHeight;
    prevScrollTopRef.current = container.scrollTop;
    loadingOldMessagesRef.current = true;
  };

  function waitForStableHeight(
    container: HTMLElement,
    stableMs = 120,
    maxWaitMs = 1000,
  ): Promise<void> {
    return new Promise((resolve) => {
      if (!(window as any).ResizeObserver) {
        // fallback: just wait a bit (images may still load though)
        setTimeout(resolve, Math.min(stableMs, maxWaitMs));
        return;
      }

      let timeoutId: ReturnType<typeof setTimeout> | null = null;
      const ro = new (window as any).ResizeObserver(() => {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          ro.disconnect();
          resolve();
        }, stableMs);
      });

      ro.observe(container);

      // safety fallback in case nothing triggers or ResizeObserver not firing as expected
      const safety = setTimeout(() => {
        try {
          ro.disconnect();
        } catch {
          /* ignore */
        }
        if (timeoutId) clearTimeout(timeoutId);
        resolve();
      }, maxWaitMs);

      // ensure cleanup if resolved early
      const cleanupResolve = () => {
        clearTimeout(safety);
        if (timeoutId) clearTimeout(timeoutId);
        try {
          ro.disconnect();
        } catch {
          /* ignore */
        }
      };
    });
  }

  useLayoutEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    // If we're not in the "loading older messages" flow, scroll to bottom for new incoming
    if (!loadingOldMessagesRef.current) {
      const nearBottom =
        container.scrollHeight - container.clientHeight - container.scrollTop <
        100;
      if (nearBottom) {
        container.scrollTop = container.scrollHeight;
      }
      return;
    }

    let mounted = true;

    (async () => {
      // give browser a chance to lay out inserted DOM nodes
      await new Promise((r) => requestAnimationFrame(r));
      // wait for stable height
      await waitForStableHeight(container);

      if (!mounted) return;

      const newScrollHeight = container.scrollHeight;
      const prevScrollHeight = prevScrollHeightRef.current || 0;
      const prevScrollTop = prevScrollTopRef.current || 0;

      // Calculate delta and set scrollTop so the visible viewport stays the same
      const delta = newScrollHeight - prevScrollHeight;
      container.scrollTop = prevScrollTop + (isFinite(delta) ? delta : 0);

      // reset flag
      loadingOldMessagesRef.current = false;
    })();

    return () => {
      mounted = false;
    };
  }, [messagesWithSeparators.length]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const handler = () => {
      if (el.scrollTop < 80 && !loadingOldMessagesRef.current) {
        // Capture state then call fetch older messages function
        prepareLoadOlder();
      }
    };
    el.addEventListener("scroll", handler);
    return () => el.removeEventListener("scroll", handler);
  }, []);

  useEffect(() => {
    if (isOpenConvo && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "auto" }); // or 'smooth'
    }
  }, [convo?.id, isOpenConvo]);

  //#endregion scroll bar section

  useEffect(() => {
    if (convo?.id) {
      setupSignalRConnection(convo?.id);
    }
  }, [convo?.id, isOpenConvo]);

  return (
    <>
      <Box
        position={
          isHuddleChatTab
            ? ["relative"]
            : showManageConvoPopup
              ? ["relative"]
              : ["fixed"]
        }
        top={isHuddleChatTab ? 0 : [`${101 - 1}px`]}
        right={isHuddleChatTab ? 0 : [!isMobile ? `${460 - 1}px` : 0]}
        w={
          isHuddleChatTab
            ? "100%"
            : isMobile
              ? "100%"
              : dimensions.width < 800
                ? "350px"
                : "460px"
        }
        h={isHuddleChatTab ? "calc(100vh - 252px)" : "calc(100vh - 50px)"}
        bgColor={["AVColor.white"]}
        shadow={isHuddleChatTab ? ["none"] : [10]}
        borderColor={"AVColor.grey"}
        borderWidth={isHuddleChatTab ? 0 : 1}
        zIndex={isHuddleChatTab ? 1 : isHeader ? -3 : 9999}
      >
        <VStack
          paddingLeft={3}
          paddingRight={isMobile ? "5px" : 3}
          h={"100%"}
          width={isHuddleChatTab ? "98%" : "100%"}
          position={"relative"}
          py={"12px"}
        >
          {/*Header*/}
          <ChatHeader
            isHuddleChatTab={isHuddleChatTab}
            isOpenConvo={isOpenConvo}
            convo={convo}
            handleNavigateToProfile={handleNavigateToProfile}
            handleuserRedirect={handleuserRedirect}
            profile={profile}
            Setprofile={Setprofile}
            handleGetEntityLink={handleGetEntityLink}
            entitydatalist={entitydatalist}
            convoSubject={convoSubject}
            fetchloading={fetchloading}
            setShowManageConvoPopup={setShowManageConvoPopup}
            showManageConvoPopup={showManageConvoPopup}
            setConvos={setConvos}
            setIsConvoData={setIsConvoData}
            setShowEmoji={setShowEmoji}
            setConvoLoading={setConvoLoading}
            setMdlCreateConvoVisible={setMdlCreateConvoVisible}
            setIsOpenConvo={setIsOpenConvo}
            toFK={toFK}
            settoFK={settoFK}
            setShowSearch={setShowSearch}
            setShowConvoListModal={setShowConvoListModal}
            setMdlConvoVisible={setMdlConvoVisible}
          />

          {!useRichText && !isOpenConvo && isGroupChat && (
            <HStack>
              <Text paddingTop={2}>{Loc.currentLang.menu.to}:</Text>
              <Box>
                <ScrollView
                  showsHorizontalScrollIndicator={false}
                  maxHeight={"250px"}
                >
                  <HStack
                    width={"350px"}
                    maxHeight={"100px"}
                    padding={"5px"}
                    flexWrap={"wrap"}
                    space={1}
                  >
                    {toFK?.map((item, i) => (
                      <HStack
                        key={item.id + i}
                        bgColor={"AVColor.primary"}
                        borderRadius={19}
                        height={"30px"}
                        alignContent={"space-around"}
                        alignSelf={"end"}
                        marginRight={"10px"}
                        marginBottom={"10px"}
                      >
                        <HStack paddingLeft={"10px"} paddingRight={"10px"}>
                          <Text
                            color={"#ffffff"}
                            fontSize={12}
                            width={"80px"}
                            numberOfLines={1}
                            text-overflow={"ellipsis"}
                            lineHeight={"2.2rem"}
                          >
                            {item.title}
                          </Text>
                          <Pressable
                            onPress={() => {
                              handleRemoveItem(item);
                            }}
                          >
                            <CloseIcon
                              marginLeft={"12px"}
                              marginTop={"12px"}
                              size={"10px"}
                              color={"#ffffff"}
                            />
                          </Pressable>
                        </HStack>
                      </HStack>
                    ))}
                    <Input
                      ref={textSearchRef}
                      autoFocus
                      size="lg"
                      borderWidth={0}
                      borderColor="gray.300"
                      variant="underlined"
                      width={"100%"}
                      onChangeText={(e) => searchItems(e)}
                      value={searchInput}
                    />
                    <Divider width="100%" />
                  </HStack>
                </ScrollView>
              </Box>
            </HStack>
          )}

          <VStack>
            {!isOpenConvo && isGroupChat ? (
              <>
                {showSearch && (
                  <Box
                    background={"#ffffff"}
                    position={"absolute"}
                    borderRadius="md"
                    shadow="9"
                    left={"40px"}
                    zIndex={999}
                    width={"249px"}
                    maxH={"170px"}
                    overflowY={"auto"}
                  >
                    {filteredResults?.map((item, i) => (
                      <Pressable
                        key={item.id + i}
                        padding={"10px"}
                        onPress={() => handleSentToProfile(item)}
                      >
                        <Box key={item.id + i}>
                          <HStack space={2}>
                            <ProfilePic
                              width={38}
                              height={38}
                              link={
                                (entitydatalist?.find(
                                  (x: IAVEntity) => x?.id == item?.id,
                                )
                                  ? AV.AVEntity.getLink(
                                      entitydatalist.find(
                                        (x: IAVEntity) => x?.id == item?.id,
                                      ) as IAVEntity,
                                    )
                                  : item) as ILink
                              }
                            />
                            <VStack marginLeft={0}>
                              {/* <Tooltip label={ item.title } openDelay={ 500 }>*/}
                              <Pressable
                                onPress={() => handleSentToProfile(item)}
                              >
                                <Text
                                  fontWeight="bold"
                                  numberOfLines={1}
                                  width="150px"
                                  text-overflow={"ellipsis"}
                                >
                                  {item?.title}
                                </Text>
                              </Pressable>
                            </VStack>
                          </HStack>
                        </Box>
                      </Pressable>
                    ))}
                  </Box>
                )}

                {toFK.length > 1 && (
                  <>
                    <Divider width={[`${400 - 1}px`]} right={3} top={2} />
                    <VStack
                      height={"100%"}
                      width="106%"
                      top={2}
                      right={[`${12 - 1}px`]}
                      zIndex={-1}
                    >
                      <TextArea
                        autoCompleteType={""}
                        value={subject}
                        defaultValue={
                          convo?.subject && isHide ? convo?.subject : subject
                        }
                        margin-Left={isMobile ? "4px" : ""}
                        onChange={handleSubject}
                        totalLines={2}
                        width={"100%"}
                        borderRadius={1}
                        fontSize={"16px"}
                        placeholder={Loc.currentLang.menu.enterSubject}
                        borderWidth={2}
                      />
                    </VStack>
                  </>
                )}

                {!useRichText && !showSearch && showFilePicker && (
                  <Box
                    alignItems="center"
                    justifyContent="center"
                    minHeight={220}
                    height={"auto"}
                    borderWidth="1"
                    borderStyle={"dashed"}
                    rounded="sm"
                    mt="1"
                    px="3"
                    py="1"
                  >
                    <FilePicker
                      getPostGallery={getImageGalleryFromFilePickerCreateConvo}
                    />
                  </Box>
                )}
              </>
            ) : (
              <>
                <VStack
                  height={
                    !isMobile && showEmoji
                      ? " calc(100vh - 675px)"
                      : !isMobile && showConvoFilePicker
                        ? " calc(100vh - 470px)"
                        : isMobile && showEmoji
                          ? " calc(100vh - 600px)"
                          : isMobile && showConvoFilePicker
                            ? " calc(100vh - 600px)"
                            : replyValue?.text?.trim()?.length < 120
                              ? " calc(100vh - 425px)"
                              : replyValue?.text?.trim()?.length > 120
                                ? " calc(100vh - 457px)"
                                : replyValue?.media && !isHuddleChatTab
                                  ? "calc(100vh - 475px)"
                                  : isMobile
                                    ? "calc(100vh - 355px)"
                                    : isHuddleChatTab
                                      ? "calc(100vh - 338px)"
                                      : "calc(100vh - 249px)"
                  }
                  overflowY={"scroll"}
                  zIndex={-3}
                >
                  <ScrollView
                    ref={scrollRef}
                    style={{ flex: 1 }}
                    contentContainerStyle={{
                      flexGrow: 1,
                      justifyContent: "flex-end", // scroll to bottom by default
                    }}
                    onScroll={({ nativeEvent }) => {
                      if (nativeEvent.contentOffset.y <= 50) {
                        onEndReached(); // Load older messages
                      }
                    }}
                    scrollEventThrottle={16}
                  >
                    {messagesWithSeparators.map((msg, index) => (
                      <Box key={msg.id || index}>
                        {renderItem({ item: msg, index })}
                      </Box>
                    ))}
                    <div ref={messagesEndRef} />
                  </ScrollView>
                </VStack>
              </>
            )}
          </VStack>

          {/*Footer*/}
          <ChatFooterEmoji
            replyValue={replyValue}
            isHuddleChatTab={isHuddleChatTab}
            images={images}
            showConvoFilePicker={showConvoFilePicker}
            isMobile={isMobile}
            setreplyValue={setreplyValue}
            ReplyLoadMedia={ReplyLoadMedia}
            isGroupChat={isGroupChat}
            isNewChat={isNewChat}
            dimensions={dimensions}
            showManageConvoPopup={showManageConvoPopup}
            typingUserName={typingUserName}
            isOpenBox={isOpenBox}
            itemEdit={itemEdit}
            showEmoji={showEmoji}
            emojiHeight={emojiHeight}
            menuRef={menuRef}
            addPhotoIconRef={addPhotoIconRef}
            onEmojiClick={onEmojiClick}
            toFK={toFK}
            subject={subject}
            isLoading={isLoading}
            handleSave={handleSave}
            setIsHide={setIsHide}
            setIsGroupChat={setIsGroupChat}
            setIsOpenConvo={setIsOpenConvo}
            setMdlConvoVisible={setMdlConvoVisible}
            setIsOpenBox={setIsOpenBox}
            setIsYouTube={setIsYouTube}
            setIsOpenCemera={setIsOpenCemera}
            setCameraMode={setCameraMode}
            imageInputRef={imageInputRef}
            menuRefs={menuRefs}
            handleOpenPicker={handleOpenPicker}
            setExternalLink={setExternalLink}
            HandleAddOneDrive={HandleAddOneDrive}
            setShowExternalLinkInput={setShowExternalLinkInput}
            showExternalLinkInput={showExternalLinkInput}
            HandleAddDropBoxLink={HandleAddDropBoxLink}
            setIsOneDriveData={setIsOneDriveData}
            Loading={Loading}
            isOpenConvo={isOpenConvo}
            handleSendConvoMessage={handleSendConvoMessage}
            handleUpdatePost={handleUpdatePost}
            handleSendMessage={handleSendMessage}
            convo={convo}
            media={media}
            value={value}
            handleVoiceRecordingComplete={handleVoiceRecordingComplete}
            isRecording={isRecording}
            setIsRecording={setIsRecording}
            showFilePicker={showFilePicker}
            setValue={setValue}
            setItemEdit={setItemEdit}
            setMedia={setMedia}
            setImages={setImages}
            setDeletedImages={setDeletedImages}
            setvideos={setvideos}
            setUpdateConvoImage={setUpdateConvoImage}
            setUpdateConvoVideo={setUpdateConvoVideo}
            setEditingImage={setEditingImage}
            setShowConvoFilePicker={setShowConvoFilePicker}
            RenderImages={RenderImages}
            setIsdelete={setIsdelete}
            isImageProcessing={isImageProcessing}
            editingImage={editingImage}
            mdlConvoVisible={mdlConvoVisible}
            handleImages={handleImages}
            handleChatMessage={handleChatMessage}
            debouncedHandleChatMessage={debouncedHandleChatMessage}
            handleMessage={handleMessage}
            isSetText={isSetText}
            waveformBars={waveformBars}
            recordingTime={recordingTime}
            setShowEmoji={setShowEmoji}
            shrink={shrink}
            handleKeyPress={handleKeyPress}
            inputRef={inputRef}
            useRichText={useRichText}
            setUseRichText={setUseRichText}
            setRteValue={setRteValue}
            entityData={entityData}
          />
        </VStack>

        {!useRichText && isOpen && (
          <Box position="fixed" bottom={0} right={0} top={0} left={0}>
            <div
              className={`create_post_popups ${
                isMobile && "create_post_popup_mobile"
              }`}
              style={{
                width: isMobile ? dimensions.width - 15 : "382px",
                right: messageMenuRight,
                height:
                  selectItem?.person?.id !== currentUser?.id
                    ? "175px"
                    : "270px",
                marginTop: "12px",
                left: isMobile ? "194px" : "",
              }}
            >
              <VStack margin={"24px"} width={"auto"} ref={menuRef}>
                <HStack
                  marginTop="20px"
                  zIndex={999}
                  width="100%"
                  height="35px"
                  space={2}
                  backgroundColor="gray.100"
                  justifyContent="space-around"
                  px={2}
                  py={1}
                  borderRadius="full"
                >
                  {feedbackOptions.map((option) => (
                    <Pressable
                      key={option?.impression}
                      onPress={() => handlePress(option.impression)}
                    >
                      <HStack>
                        <Tooltip
                          title={option?.title}
                          enterDelay={100}
                          leaveDelay={0}
                          arrow
                          placement="top"
                        >
                          <Image
                            source={{ uri: option.uri }}
                            alt={option.title}
                            size="24px"
                          />
                        </Tooltip>
                      </HStack>
                    </Pressable>
                  ))}
                </HStack>

                {(selectItem?.media === undefined ||
                  selectItem?.media?.type === undefined ||
                  !selectItem?.media?.type?.startsWith("audio")) && (
                  <>
                    <Divider marginY={"5px"} />
                    {selectItem?.person?.id === currentUser?.id && (
                      <Button
                        width="100%"
                        height="50px"
                        paddingX="40px"
                        background="white"
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        _hover={{ backgroundColor: "gray.100" }}
                        onPress={() => {
                          HandleEditSet(selectItem);
                          setreplyValue(""); // Ensure correct handling
                          setIsOpen(false);
                          //if (selectItem?.ptype === "H") {
                          //   setItemEdit(selectItem);
                          //   setRteValue(selectItem?.text ?? "");
                          //   setUseRichText(true);
                          //}
                        }}
                      >
                        <Text
                          paddingLeft="30px"
                          fontSize="14px"
                          fontFamily="Roboto"
                        >
                          {Loc.currentLang.menu.edit}
                        </Text>
                      </Button>
                    )}
                  </>
                )}

                {selectItem?.person?.id === currentUser?.id && (
                  <Divider marginY={"5px"} />
                )}
                <Button
                  width={"100%"}
                  height={"50px"}
                  paddingX={"40px"}
                  background={"white"}
                  alignItems={"flex-start"}
                  justifyContent={"flex-start"}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                  onPress={() => {
                    setreplyValue(selectItem);
                    setIsOpen(false);
                  }}
                >
                  <Text
                    paddingLeft={"30px"}
                    fontSize={"14px"}
                    fontFamily={"Roboto"}
                  >
                    {Loc.currentLang.menu.reply}
                  </Text>
                </Button>
                {selectItem?.person?.id === currentUser?.id && (
                  <Divider marginY={"5px"} />
                )}
                {selectItem?.person?.id === currentUser?.id && (
                  <Button
                    width={"100%"}
                    height={"50px"}
                    paddingX={"40px"}
                    alignItems={"flex-start"}
                    justifyContent={"flex-start"}
                    background={isDeleteLoading ? "#32AE78" : "white"}
                    isLoading={isDeleteLoading}
                    _hover={{
                      backgroundColor: "gray.100",
                    }}
                    onPress={handleDeleteMessage}
                  >
                    <Text
                      paddingLeft={"30px"}
                      fontSize={"14px"}
                      fontFamily={"Roboto"}
                    >
                      {Loc.currentLang.menu.delete}
                    </Text>
                  </Button>
                )}
              </VStack>
            </div>
          </Box>
        )}

        {!useRichText && isOpenCemera && (
          <Box
            position="fixed"
            bgColor="rgba(0, 0, 0, 0.25)"
            bottom={0}
            right={0}
            top="40px"
            left={0}
            zIndex={99999}
            display="flex"
            alignItems="center"
            justifyContent="center"
            overflowY="auto"
            px="16px"
          >
            <Box
              bg="white"
              borderRadius="12px"
              p="20px"
              w="100%"
              maxW="750px"
              maxH="95vh"
              overflowY="auto"
            >
              <VStack space={4}>
                {/* Webcam preview */}
                <Box w="100%" position="relative">
                  <Webcam
                    audio={cameraMode === "video"}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    videoConstraints={{ facingMode: "user" }}
                    style={{
                      width: "100%",
                      height: "400px",
                      borderRadius: "8px",
                      objectFit: "cover",
                    }}
                  />

                  {/* Timer Overlay */}
                  {cameraMode === "video" && recording && (
                    <Box
                      position="absolute"
                      top="12px"
                      right="16px"
                      px="8px"
                      py="4px"
                      backgroundColor="rgba(0,0,0,0.6)"
                      borderRadius="md"
                    >
                      <Text color="white" fontWeight="bold" fontSize="md">
                        ⏺ {formatDuration(duration)}
                      </Text>
                    </Box>
                  )}
                </Box>

                {/* Buttons */}
                <HStack
                  flexWrap="wrap"
                  justifyContent="flex-end"
                  space={3}
                  mt="20px"
                  zIndex={100000}
                >
                  {/* Toggle Camera Mode */}
                  <div
                    className="toggleContainer"
                    style={{ display: "none", gap: "12px" }}
                  >
                    <div
                      className={`iconBox ${cameraMode === "photo" ? "active" : "inactive"}`}
                      onClick={() => toggleMode()}
                    >
                      <FiCamera size={24} />
                    </div>
                    <div
                      className={`iconBox ${cameraMode === "video" ? "active" : "inactive"}`}
                      onClick={() => toggleMode()}
                    >
                      <FiVideo size={24} />
                    </div>
                  </div>

                  {/* Cancel Button */}
                  <Button
                    height="40px"
                    minW="120px"
                    backgroundColor="rgba(238, 238, 238, 1)"
                    borderRadius="full"
                    onPress={() => {
                      if (recording) {
                        isCancelledRef.current = true;
                        handleStopRecording();
                      }
                      onClose();
                    }}
                  >
                    <Text
                      color="rgba(0, 0, 0, 0.5)"
                      fontSize="16px"
                      fontWeight={400}
                    >
                      {Loc.currentLang.postPopup.cancel}
                    </Text>
                  </Button>

                  {/* Capture / Record Button */}
                  {cameraMode === "photo" ? (
                    <Button
                      height="40px"
                      minW="120px"
                      backgroundColor="AVColor.primary"
                      borderRadius="full"
                      isLoading={isImageProcessing}
                      onPress={handleCameraPhotoCapture}
                      //isDisabled={!isCameraAccessible}
                    >
                      <Text color="white" fontSize="16px" fontWeight={400}>
                        {Loc.currentLang.postPopup.capture}
                      </Text>
                    </Button>
                  ) : (
                    <Button
                      height="40px"
                      minW="120px"
                      backgroundColor={
                        recording ? "red.500" : "AVColor.primary"
                      }
                      borderRadius="full"
                      //isDisabled={!isCameraAccessible}
                      onPress={() => {
                        if (recording) {
                          isCancelledRef.current = false;
                          handleStopRecording();
                        } else {
                          handleStartRecording();
                        }
                      }}
                    >
                      <Text color="white" fontSize="16px" fontWeight={400}>
                        {recording
                          ? Loc.currentLang.postPopup.stop
                          : Loc.currentLang.postPopup.record}
                      </Text>
                    </Button>
                  )}
                </HStack>
              </VStack>
            </Box>
          </Box>
        )}

        {!useRichText && showExternalLinkInput && !isOpenCemera && (
          <Box
            position="fixed"
            bgColor={"AVColor.overlay2"}
            bottom={0}
            right={0}
            top={0}
            left={0}
          >
            <div
              className={`create_post_popup ${
                isMobile && "create_post_popup_mobile"
              }`}
              style={{
                width: isMobile ? dimensions.width - 15 : "565px",
                height: isMobile ? "650px" : "240px",
                marginTop: "12px",
              }}
            >
              <VStack width={"100%"} padding={"24px"}>
                <HStack
                  justifyContent={"space-between"}
                  width={"100%"}
                  alignItems={"center"}
                  marginTop={"20px"}
                  borderBottomColor={"AVColor.grey"}
                >
                  <Text fontSize={"24px"}>
                    {isYoutube
                      ? Loc.currentLang.menu.addYoutubeUrl
                      : Loc.currentLang.postPopup.addPostUrl}
                  </Text>
                  <AVCancel
                    callback={() => {
                      setShowExternalLinkInput(false);
                    }}
                    color={undefined}
                    size={undefined}
                  />
                </HStack>
                <HStack width={"100%"} marginTop={"24px"}>
                  <Box width={"95%"} justifyContent="center">
                    <AVInputtext
                      type={"text"}
                      label={
                        isYoutube
                          ? Loc.currentLang.menu.addYoutubeUrl
                          : Loc.currentLang.postPopup.addPostUrl
                      }
                      maxLength={undefined}
                      onChange={handleExternalLink}
                      defaultValue={undefined}
                      width={undefined}
                      value={externalLink}
                      height={"20px"}
                      minRows={undefined}
                      multiline={undefined}
                      size={undefined}
                      placeholder={undefined}
                    />
                  </Box>
                </HStack>
                <HStack
                  justifyContent={"center"}
                  space={"24px"}
                  marginTop={"24px"}
                >
                  <Button
                    width={"180px"}
                    height={"40px"}
                    backgroundColor={"AVColor.primary"}
                    rounded={"full"}
                    isDisabled={externalLink?.trim().length === 0}
                    isLoading={Loading}
                    onPress={() => HandleAddExternalUrl()}
                  >
                    <Text fontWeight={500} color={"white"}>
                      {Loc.currentLang.menu.ok}
                    </Text>
                  </Button>
                </HStack>
              </VStack>
            </div>
          </Box>
        )}

        {isConfirmDelete && (
          <AVConfirmationModal
            showconfirmationPopup={isConfirmDelete}
            setshowconfirmationPopup={setisConfirmDelete}
            Confirmationtext={Confirmationtext}
            type={selectType}
            item={itemSelect}
            function={selectType == "DeleteConvo" ? handleDelteconvo : ""}
            isLoader={isLoader}
          />
        )}

        {showInsufficientCredits && (
          <Box
            position="fixed"
            top={0}
            bottom={0}
            left={0}
            right={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
            backgroundColor="rgba(0, 0, 0, 0.25)"
            zIndex={9999}
          >
            <div className="customModal">
              <div className="show_unauthorized_details">
                <VStack position="relative" padding="24px">
                  {/* Close Button */}
                  <Pressable
                    padding={1.5}
                    rounded="full"
                    zIndex={999}
                    position="absolute"
                    top="20px"
                    right="20px"
                    _hover={{ backgroundColor: "AVColor.hovercolor2" }}
                    backgroundColor="AVColor.buttonBg"
                    onPress={() => setShowInsufficientCredits(false)}
                  >
                    <CloseIcon size="16px" color="AVColor.secondaryText" />
                  </Pressable>

                  {/* Title */}
                  <HStack justifyContent="center" marginBottom="12px">
                    <Text fontSize="20px" fontWeight="bold" color="#000000">
                      {Loc.currentLang.purchaseCredits.insufficientCredits}
                    </Text>
                  </HStack>

                  {/* Image */}
                  <HStack justifyContent="center" marginBottom="12px">
                    <img
                      src={InsufficientCredits}
                      style={{ width: "101px", height: "112px" }}
                    />
                  </HStack>

                  {/* Credit Text */}
                  <HStack justifyContent="center">
                    <Text color="#FF4400D9" fontSize="24px" textAlign="center">
                      0 {Loc.currentLang.purchaseCredits.Credits}
                    </Text>
                  </HStack>

                  {/* Message */}
                  <HStack justifyContent="center" marginTop="5px">
                    <Text color="#00000080" fontSize="18px" textAlign="center">
                      {Loc.currentLang.purchaseCredits.enoughCreditsMsg}
                    </Text>
                  </HStack>

                  {/* Buttons */}
                  <HStack justifyContent="center" marginTop="40px" space={4}>
                    <Button
                      rounded="full"
                      backgroundColor="#EEEEEE"
                      width="225px"
                      height="40px"
                      onPress={() => setShowInsufficientCredits(false)}
                    >
                      <Text
                        fontSize="16px"
                        color="rgba(0,0,0,0.5)"
                        fontWeight="bold"
                      >
                        {Loc.currentLang.menu.cancelCaps}
                      </Text>
                    </Button>

                    <Button
                      rounded="full"
                      backgroundColor="#32AE78"
                      width="225px"
                      height="40px"
                      onPress={() =>
                        navigate(
                          `/accountsettings/${selectItem?.id}/${selectItem?.region}`,
                          {
                            state: {
                              triggerBuyCredits: true,
                              page: "AutoTranslation",
                              accountsetting: "HomePage",
                              Entity: currentUser,
                            },
                          },
                        )
                      }
                    >
                      <Text fontSize="16px" color="#FFFFFF" fontWeight="bold">
                        {Loc.currentLang.manageConversation.buyCredits}
                      </Text>
                    </Button>
                  </HStack>
                </VStack>
              </div>
            </div>
          </Box>
        )}
      </Box>

      {useRichText && (
        <FormattingPostPopup
          editorRef={editorRef}
          useRichText={useRichText}
          setUseRichText={setUseRichText}
          rteValue={rteValue}
          setRteValue={setRteValue}
          toolbarOptions={toolbarOptions}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          setPostPopupExpanded={setPostPopupExpanded}
          bgColor={bgColor}
          setBgColor={setBgColor}
          bgImage={bgImage}
          setBgImage={setBgImage}
          bgImgWidth={bgImgWidth}
          setBgImgWidth={setBgImgWidth}
          bgImgHeight={bgImgHeight}
          setBgImgHeight={setBgImgHeight}
          isOpenConvo={isOpenConvo}
          entityStatus={entityData?.status}
          toFK={toFK}
          subject={subject}
          isConfirmDelete={isConfirmDelete}
          convo={convo}
          handleSendConvoMessage={handleSendConvoMessage}
          isLoading={isLoading}
          itemEdit={itemEdit}
          setItemEdit={setItemEdit}
          handleUpdatePost={handleUpdatePost}
          setIsOneDriveData={setIsOneDriveData}
          isYoutube={isYoutube}
          setIsYouTube={setIsYouTube}
          isOpenCemera={isOpenCemera}
          setIsOpenCemera={setIsOpenCemera}
          cameraMode={cameraMode}
          setCameraMode={setCameraMode}
          externalLink={externalLink}
          setExternalLink={setExternalLink}
          showExternalLinkInput={showExternalLinkInput}
          setShowExternalLinkInput={setShowExternalLinkInput}
          addLinkLoad={addLinkLoad}
          handleOpenPicker={handleOpenPicker}
          HandleAddOneDrive={HandleAddOneDrive}
          HandleAddDropBoxLink={HandleAddDropBoxLink}
          handleExternalLink={handleExternalLink}
          HandleAddExternalUrl={HandleAddExternalUrl}
          webcamRef={webcamRef}
          recording={recording}
          duration={duration}
          formatDuration={formatDuration}
          toggleMode={toggleMode}
          isCancelledRef={isCancelledRef}
          handleCameraPhotoCapture={handleCameraPhotoCapture}
          handleStartRecording={handleStartRecording}
          handleStopRecording={handleStopRecording}
          onClose={onClose}
          Loading={Loading}
          RenderImages={RenderImages}
          handleImages={handleImages}
          images={images}
          setImages={setImages}
          setIsdelete={setIsdelete}
          setDeletedImages={setDeletedImages}
          setUpdateConvoImage={setUpdateConvoImage}
          setUpdateConvoVideo={setUpdateConvoVideo}
          media={media}
          setMedia={setMedia}
          isImageProcessing={isImageProcessing}
          editingImage={editingImage}
          setEditingImage={setEditingImage}
          setShowConvoFilePicker={setShowConvoFilePicker}
        />
      )}
    </>
  );
};

export default React.memo(Messages);
